.button { display: inline-flex; padding: 0; line-height: 0; }
.button:disabled { opacity: 0.5; cursor: progress; }
